import { useRouter } from 'next/router';
import { useMemo } from 'react';

export type QueryParams = {
  counterNumber: number | undefined;
  tableNumber: number | undefined;
  localId: number | undefined;
};

export function useQueryParamsWithNextRouter(): QueryParams {
  const { query } = useRouter();
  return useQueryParams(query);
}

type Query = { [key: string]: string | undefined | string[] };

export function useQueryParams(query: Query): QueryParams {
  const tableNumber = useMemo(() => {
    const tableParam = query?.mesa;
    const tableParamAsNumber = Number(tableParam);

    const isInvalidQueryParam = Boolean(!tableParam || tableParam instanceof Array || isNaN(tableParamAsNumber));
    if (isInvalidQueryParam) return undefined;

    return tableParamAsNumber;
  }, [query]);

  const counterNumber = useMemo(() => {
    const counterParam = query?.balcao;
    const counterParamAsNumber = Number(counterParam);

    const isInvalidQueryParam = Boolean(!counterParam || isNaN(counterParamAsNumber));
    if (isInvalidQueryParam) return undefined;

    return counterParamAsNumber;
  }, [query]);

  const localId = useMemo(() => {
    if (!query) return undefined;

    if (query.params?.[0] === 'local' && isNumber(query.params?.[1])) {
      return Number(query.params[1]);
    }

    return undefined;
  }, [query]);

  return {
    counterNumber,
    tableNumber,
    localId,
  };
}

function isNumber(str: string) {
  return !isNaN(Number(str));
}

export const WindowHistory = {
  pushWithQueryParams(pathname: string) {
    window.history.pushState(null, '', pathname + window.location.search);
  },

  replaceWithQueryParams(pathname: string) {
    window.history.replaceState(null, '', pathname + window.location.search);
  },
};

export function removeHashOfUrl(hashToRemove: string) {
  let hash = hashToRemove;
  if (hash[0] !== '#') hash = `#${hash}`;

  if (window.location.hash === hash) window.location.hash = '';
}
